
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalEmpty as ObiBatteryHorizontalEmptyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-empty.js';
 
 
 

 
 export const ObiBatteryHorizontalEmpty = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-empty',
   elementClass: ObiBatteryHorizontalEmptyElement,
   events: {
     
   }
  });
 
 